<div>
    <div class="d-flex align-items-center">
        <div class="info-title">
            Policy
        </div>
        <div *ngIf="_licenseScopeMap[_enumLicenseScope.devicePolicy]; else tplNoLicense"
            class="d-flex align-items-center ml-2">
            <ng-container *ngIf="_device?.virtualId">
                <button *ngIf="!_isPolicyPaused; else tplPolicyPaused" type="button" [disabled]="_loading"
                    data-toggle="modal" data-target="#devPolicyFuncModalHost" class="btn btn-sm btn-action btn-light"
                    (click)="pausePolicy()">
                    Pause
                </button>
                <ng-template #tplPolicyPaused>
                    <button type="button" class="btn btn-sm btn-action btn-light"
                        [disabled]="_loading || _bConfigPolicyPauseStatus" (click)="resumePolicy()">
                        Resume
                    </button>
                    <small *ngIf="_pauseEndDateTime" class="badge ml-2">
                        (pause until {{ _pauseEndDateTime | date:'yyyy-MM-dd HH:mm' }})
                    </small>
                </ng-template>
            </ng-container>
            <div *ngIf="_bConfigPolicyPauseStatus" class="loading py-0 px-2">
                <div class="loading-box m-0"></div>
            </div>
        </div>
        <ng-template #tplNoLicense>
            <div class="ml-2 red-1 note">
                ( Not applicable )
            </div>
        </ng-template>
    </div>
    <div class="ml-4">
        <ng-container *ngIf="_licenseScopeMap[_enumLicenseScope.devicePolicy]">
            <span *ngIf="_loading; else tplShowPolicy" class="text-loading" [attr.data-text]="TEXT_LOADING">
                {{ TEXT_LOADING }}
            </span>
            <ng-template #tplShowPolicy>
                <ng-container *ngIf="_errorMessage; else templateNoError">
                    <div class="text-warning">{{ _errorMessage }}</div>
                </ng-container>
                <ng-template #templateNoError>
                    <div *ngFor="let pod of _policyMap | keyvalue" class="form-group row">
                        <label [for]="'col-policy-configuration-' + pod.key"
                            class="col-xl-4 col-5 col-form-label col-form-label-sm">
                            {{ pod.key }}
                        </label>
                        <div class="col-xl-8 col-7">
                            <div [id]="'col-policy-configuration-' + pod.key" class="form-control-plaintext">
                                <span *ngFor="let p of pod.value.list">
                                    <a [routerLink]="'/app/device/policy/' + p.id">{{ p.name }}</a>
                                </span>
                                <ng-container *ngIf="_isPolicyPaused; else tplPolicyNormalStatus">
                                    <span class="ml-1 policy-status status-paused">
                                        {{ TEXT_PAUSED | capitalFirstWord }}
                                    </span>
                                </ng-container>
                                <ng-template #tplPolicyNormalStatus>
                                    <span class="ml-1 policy-status" [ngClass]="'status-' + pod.value.status">
                                        {{ pod.value.status }}
                                    </span>
                                    <span *ngIf="pod.value.isPartialSync" class="dropdown">
                                        <i class="fas fa-info-circle red-1 ml-1" data-toggle="collapse"
                                            data-target="#dropdownPolicyPartialDesc" aria-expanded="false"
                                            aria-controls="dropdownPolicyPartialDesc"></i>
                                        <ul class="collapse" id="dropdownPolicyPartialDesc">
                                            <li *ngFor="let partialSyncPolicyDesc of pod.value.partialSyncDescList">
                                                {{ partialSyncPolicyDesc }}
                                            </li>
                                        </ul>
                                    </span>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </ng-template>
        </ng-container>
    </div>
</div>
<div id="devPolicyFuncModalHost" class="modal fade" tabindex="-1" data-backdrop="static" data-keyboard="false"
    role="dialog">
    <ng-template dev-func-host></ng-template>
</div>